// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Arakan examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import AuthService from "services/auth-service";
import CrudService from "services/cruds-service";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import { Autocomplete, Grid } from "@mui/material";
import ComplexProjectCard from "components/ComplexProjectCard";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MainInfo from "./edit-landing-page/components/MainInfo";
import FormField from "components/FormField";
import MDButton from "components/MDButton";
import LangForm from "./edit-landing-page/components/LangForm";
import prepareNewArr from "helper/prepareNewArr";
import ArticleImage from "./edit-landing-page/components/ArticleImage";
import { set } from "date-fns";
import MDInput from "components/MDInput";
import { Visibility } from "@mui/icons-material";
import isFieldVisible from "helper/isFieldVisable";

function LandingPage() {
  let { state } = useLocation();
  const ability = useAbility(AbilityContext);
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [idForMenu, setIdForMenu] = useState(null);
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });
  const [article, setArticle] = useState(null);
  const [info, setInfo] = useState(null);
  const [linfo, setLInfo] = useState(null);
  const [projects, setProjects] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [reports, setReports] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [page, setPage] = useState(null);
  const [pages, setPages] = useState([]);
  const [errors, setErrors] = useState({
    id: false,
    order: false,
    isVisible: false,
  });

  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    (async () => {
      const { data } = await AuthService.getProfile();
      setIsAdmin(
        ability.can("edit", "articles") || data.role?.name === "Administrator",
      );
      getAllData();
    })();
  }, []);

  useEffect(() => {
    setInfo(null);
    if (!article) return;
    setInfo({
      ...article,
      // effect: { id: article.effect, name: article.effect },
    });
  }, [article]);

  const getAllData = async () => {
    //

    // const resp = await CrudService.getAllData(
    //   `items/pagesDesign?filter[page][_eq]=97&sort=order`
    // );
    // resp.data.map(async (r) => {
    //   delete r.id;
    //   delete r.user_updated;
    //   delete r.date_updated;
    // await CrudService.createItem(`items/pagesDesign`, r);
    // });
    //

    // const URL = `items/pagesDesign?fields=*,page.arname`;
    // const response = await CrudService.getAllData(URL);
    // setData(response.data);

    // const projectsData = await CrudService.getAllData(
    //   `items/projects?fields=id,translations.name`
    // );
    // setProjects(prepareNewArr(projectsData.data));

    // const blogsData = await CrudService.getAllData(
    //   `items/article?fields=id,translations.title&filter[type][_eq]=b`
    // );
    // setBlogs(prepareNewArr(blogsData.data, "title"));
    // const reportsData = await CrudService.getAllData(
    //   `items/reports?fields=id,translations.title`
    // );
    // setReports(prepareNewArr(reportsData.data, "title"));
    // const faqData = await CrudService.getAllData(
    //   `items/faq?fields=id,translations.question`
    // );
    // setFaqs(prepareNewArr(faqData.data, "question"));
    const pagesData = await CrudService.getAllData(
      `items/pages?fields=*&filter[active][_eq]=true`,
    );
    setPages(pagesData.data);
    setPage(pagesData.data.filter((p) => p.id === 1)[0]);
  };

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  const getDefaultData = async (page) => {
    const URL = `items/pagesDesign?fields=*,page.id,page.arname&filter[page][_eq]=${page.id}&sort=order`;
    const response = await CrudService.getAllData(URL);
    // Usage:
    // const result = extractValuesFromDataStructure(response.data);
    // console.log(result);
    setData(response.data);
  };

  function extractValuesFromDataStructure(data) {
    const resultMap = new Map();

    data.forEach((item) => {
      const type = item.type;
      if (!type) return;

      if (!resultMap.has(type)) {
        resultMap.set(type, new Set());
      }

      const valuesSet = resultMap.get(type);

      // Function to extract all non-empty string values from an object
      function extractStringsFromObj(obj, path = "") {
        if (!obj || typeof obj !== "object") return;

        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            const currentPath = path ? `${path}_${key}` : key;

            if (typeof value === "string" && value.trim() !== "") {
              valuesSet.add(currentPath);
            } else if (typeof value === "object" && value !== null) {
              extractStringsFromObj(value, currentPath);
            }
          }
        }
      }

      // Extract from content array
      if (Array.isArray(item.content)) {
        item.content.forEach((contentItem, index) => {
          if (contentItem && typeof contentItem === "object") {
            extractStringsFromObj(contentItem, `content_${index}`);
          }
        });
      }

      // Extract from data object
      if (item.data && typeof item.data === "object") {
        extractStringsFromObj(item.data, "data");
      }

      // Extract from direct properties (excluding arrays and objects already processed)
      const directProps = ["effect", "speed", "icon_name"];
      directProps.forEach((prop) => {
        if (
          item[prop] &&
          typeof item[prop] === "string" &&
          item[prop].trim() !== ""
        ) {
          valuesSet.add(prop);
        }
      });

      // Extract translations from content if they exist
      if (Array.isArray(item.content)) {
        item.content.forEach((contentItem, contentIndex) => {
          if (
            contentItem?.translations &&
            typeof contentItem.translations === "object"
          ) {
            for (const lang in contentItem.translations) {
              if (contentItem.translations[lang]) {
                extractStringsFromObj(
                  contentItem.translations[lang],
                  `content_${contentIndex}_translations_${lang}`,
                );
              }
            }
          }
        });
      }

      // Extract translations from data if they exist
      if (
        item.data?.translations &&
        typeof item.data.translations === "object"
      ) {
        for (const lang in item.data.translations) {
          if (item.data.translations[lang]) {
            extractStringsFromObj(
              item.data.translations[lang],
              `data_translations_${lang}`,
            );
          }
        }
      }
    });

    // Convert Map to array of objects
    const result = [];
    for (const [type, valuesSet] of resultMap) {
      const valuesArray = Array.from(valuesSet);

      // Clean up the keys by removing numeric indices for readability
      const cleanedValues = valuesArray.map((value) => {
        // Remove numeric indices from paths like content_0, content_1, etc.
        const parts = value.split("_");
        const cleanedParts = parts.map((part) => {
          // Check if part is a number (index)
          if (!isNaN(part) && part.trim() !== "") {
            return "index"; // Replace numeric indices with 'index'
          }
          return part;
        });

        // Join back with underscore and remove duplicate 'index' parts
        let result = cleanedParts[0];
        for (let i = 1; i < cleanedParts.length; i++) {
          if (
            !(cleanedParts[i] === "index" && cleanedParts[i - 1] === "index")
          ) {
            result += "_" + cleanedParts[i];
          }
        }

        return result;
      });

      // Remove duplicates that might have been created during cleaning
      const uniqueCleanedValues = [...new Set(cleanedValues)];

      result.push({
        type: type,
        values: uniqueCleanedValues.sort(), // Sort alphabetically for better readability
      });
    }

    return result;
  }

  useEffect(() => {
    page?.id && getDefaultData(page);
  }, [page]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const [slackBotMenu, setSlackBotMenu] = useState(null);

  const openSlackBotMenu = (event, d) => {
    setSlackBotMenu(event.currentTarget);
    setIdForMenu(d);
  };

  const closeSlackBotMenu = () => setSlackBotMenu(null);

  // Dropdown menu template for the ComplexProjectCard
  const renderMenu = (state, close) => {
    return (
      <Menu
        anchorEl={state}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(state)}
        onClose={close}
        keepMounted
      >
        {idForMenu?.type !== "blogs_list" &&
          idForMenu?.type !== "faq" &&
          idForMenu?.type !== "projects_list" &&
          idForMenu?.type !== "reports" &&
          idForMenu?.type !== "rohingya_video" &&
          idForMenu?.type !== "rohingya_footer" &&
          idForMenu?.type !== "3ta2_background" &&
          idForMenu?.type !== "title" &&
          idForMenu?.type !== "3ta2_info" && (
            <MenuItem
              onClick={() => {
                navigate(`/websiteManagement/edit/page/${idForMenu.id}`);
              }}
            >
              عرض
            </MenuItem>
          )}
        <MenuItem
          onClick={() => {
            setArticle(idForMenu);
            close();
          }}
        >
          تعديل
        </MenuItem>
        {/* <MenuItem onClick={close}>Another action</MenuItem> */}
        {/* <MenuItem onClick={close}>Something else here</MenuItem> */}
      </Menu>
    );
  };

  // const changeVisibletyHandller = async (id, v) => {
  //   await CrudService.updateItem(`items/pagesDesign/${id}`, { isVisible: v });
  //   getAllData();
  // };

  // const changeOrderyHandller = async (id, v) => {
  //   await CrudService.updateItem(`items/pagesDesign/${id}`, { order: v });
  //   getAllData();
  // };

  const submitHandler = async (e) => {
    e.preventDefault();

    // const trns1 = Object.values(linfo.translations);
    // console.log(trns1, article);

    // return;
    if (info.web_pic && info.web_pic instanceof File) {
      article?.web_pic && (await CrudService.removeFile(article.web_pic));
      const formData = new FormData();
      formData.append("attachment", info.web_pic);
      // const { data } = await HttpService.post(imageUpdate, formData, true);
      let img = await CrudService.uploadImage(formData);
      info.data.web_pic = img.id;
    } else if (info.web_pic === null) {
      delete info.web_pic;
    }

    if (info.mobile_pic && info.mobile_pic instanceof File) {
      article?.mobile_pic && (await CrudService.removeFile(article.mobile_pic));
      const formData = new FormData();
      formData.append("attachment", info.mobile_pic);
      let img = await CrudService.uploadImage(formData);
      info.data.mobile_pic = img.id;
    } else if (info.mobile_pic === null) {
      delete info.mobile_pic;
    }
    const trns = Object.values(linfo.translations);

    for (const key in trns) {
      if (!Object.hasOwn(trns, key)) continue;

      const item = trns[key];
      if (item.pic && item.pic instanceof File) {
        article.data.translations[item.languages_code]?.pic &&
          (await CrudService.removeFile(
            article.data.translations[item.languages_code].pic,
          ));
        const formData = new FormData();
        formData.append("attachment", item.pic);
        let img = await CrudService.uploadImage(formData);
        item.pic = img.id;
      } else if (item.pic === null) {
        delete item.pic;
      }
    }

    const { id, date_updated, user_updated, data, page, ...rest } = info;
    if (info.iconName) data.iconName = info.iconName;
    await CrudService.updateItem(`items/pagesDesign/${id}`, {
      ...rest,
      data: { ...data, ...linfo },
    });
    setArticle(null);
    getDefaultData(page);
    setNotification({
      value: true,
      color: "success",
      text: "تم الحفظ بنجاح",
    });
  };

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    if (name === "iconName") {
      setInfo({
        ...info,
        data: { iconName: v },
      });
    } else
      setInfo({
        ...info,
        [name]: v,
      });
  };

  return (
    <DashboardLayout>
      {notification.value && (
        <MDAlert color={notification.color} my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pb={3}>
        <MDBox mb={3}>
          <MDBox mb={6}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} lg={6}>
                <MDTypography variant="h4" fontWeight="medium">
                  صفحات الموقع
                </MDTypography>
              </Grid>

              <Grid item xs={12} lg={6}>
                {article && (
                  <MDBox display="flex" justifyContent="flex-end">
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={submitHandler}
                    >
                      حفظ
                    </MDButton>
                  </MDBox>
                )}
              </Grid>
              <Grid item xs={12} lg={12}>
                <Autocomplete
                  options={pages}
                  name="pages"
                  value={page}
                  onChange={(e, v) => setPage(v)}
                  renderOption={(props, option) => {
                    const { key, ...rest } = props;
                    return (
                      <li key={key} {...rest}>
                        {option.data ? option.data.arname : option.arname}
                      </li>
                    );
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                      const { key, ...pageProps } = getTagProps({ index });
                      return (
                        <Chip
                          key={option.id || key}
                          {...pageProps}
                          label={option.data?.arname || option.arname}
                        />
                      );
                    })
                  }
                  getOptionLabel={(option) =>
                    option?.data?.arname || option?.arname || ""
                  }
                  isOptionEqualToValue={(option, item) =>
                    option?.id === item?.id
                  }
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      variant="outlined"
                      label="الصفحات"
                      error={errors.pages}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </MDBox>
          <Grid container spacing={3}>
            {data.map((d) => (
              <Grid item xs={12} md={6} lg={4} key={d.id}>
                <MDBox mb={1.5} mt={1.5}>
                  <ComplexProjectCard
                    color={"secondary"}
                    isIcon={true}
                    icon_name={d.icon_name}
                    title={d.data?.translations["ar-SA"]?.title || "بدون عنوان"}
                    members={
                      d.type === "about_us" || d.type === "3ta2_background"
                        ? [
                            {
                              type: "image",
                              src: `${baseUrl}assets/${d.data.web_pic}`,
                            },
                          ]
                        : d.type !== "blogs_list" &&
                          d.type !== "faq" &&
                          d.type !== "projects_list" &&
                          d.type !== "reports" &&
                          d.type !== "rohingya_video" &&
                          d.type !== "rohingya_footer" &&
                          d.type !== "todolist" &&
                          d.type !== "title" &&
                          d.type !== "3ta2_info"
                        ? d.content.map((c) =>
                            c?.web_pic
                              ? {
                                  type: "image",
                                  src: `${baseUrl}assets/${c.web_pic}`,
                                }
                              : { type: "icon", iconName: c.iconName },
                          )
                        : []
                    }
                    dropdown={{
                      action: (a) => openSlackBotMenu(a, d),
                      menu: renderMenu(slackBotMenu, closeSlackBotMenu),
                    }}
                  />
                </MDBox>
              </Grid>
            ))}
          </Grid>
          {article && (
            <Grid container spacing={3} mt={2}>
              <Grid
                item
                xs={12}
                lg={
                  article.type === "slider" || article.type === "identity"
                    ? 12
                    : 3
                }
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={12}>
                    <MainInfo
                      // article.type === "slider" ? "slider" :
                      prefix="data_"
                      isFieldVisible={isFieldVisible}
                      main={true}
                      type={article.type}
                      article={article}
                      changeHandler={changeHandler}
                      autoSwitchChangeHandler={autoSwitchChangeHandler}
                      setInfo={setInfo}
                      info={info}
                      setErrors={setErrors}
                      errors={errors}
                      notification={notification}
                      setNotification={setNotification}
                      projects={
                        article.type === "projects_list"
                          ? projects
                          : article.type === "blogs_list"
                          ? blogs
                          : article.type === "faq"
                          ? faqs
                          : reports
                      }
                      isMain={true}
                    />
                  </Grid>
                  {(article.type === "about_us" ||
                    article.type === "receipt" ||
                    // article.type === "footer" ||
                    article.type === "3ta2_background" ||
                    article.type === "rohingya_footer" ||
                    isFieldVisible("data_web_pic", article.type)) && (
                    <Grid item xs={12} lg={12}>
                      <ArticleImage
                        articleImage={`${baseUrl}assets/${article?.data.web_pic}`}
                        changeHandler={changeHandler}
                        imgInfo={{ name: "صورة الموقع", dimentions: "" }}
                        setInfo={setInfo}
                        info={info}
                        notification={notification}
                        setNotification={setNotification}
                        errors={errors}
                        setErrors={setErrors}
                        name="web_pic"
                        isMain={true}
                      />
                    </Grid>
                  )}
                  {/* {(article.type === "about_us" ||
                    article.type === "contact_us" ||
                    article.type === "footer" ||
                    article.type === "3ta2_background" ||
                    article.type === "rohingya_footer") && (
                    <Grid item xs={12} lg={12}>
                      <ArticleImage
                        articleImage={`${baseUrl}assets/${article?.data.mobile_pic}`}
                        changeHandler={changeHandler}
                        imgInfo={{ name: "صورة الهاتف", dimentions: "300x300" }}
                        setInfo={setInfo}
                        info={info}
                        notification={notification}
                        setNotification={setNotification}
                        errors={errors}
                        setErrors={setErrors}
                        name="mobile_pic"
                        isMain={true}
                      />
                    </Grid>
                  )} */}
                </Grid>
              </Grid>
              {article.type !== "slider" && article.type !== "identity" && (
                <Grid item xs={12} lg={9}>
                  <LangForm
                    isFieldVisible={isFieldVisible}
                    prefix="data_"
                    type={article.type}
                    article={article.data}
                    changeHandler={changeHandler}
                    setInfo={setLInfo}
                    info={linfo}
                    notification={notification}
                    setNotification={setNotification}
                    errors={errors}
                    setErrors={setErrors}
                    isMain={true}
                  />
                </Grid>
              )}
            </Grid>

            // </MDBox>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LandingPage;
